(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alo-header-style"]) return;
  try {
    
  const excludedTags = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'PRE', 'CODE']);
  const dashCharacters = /\s*(?:--|—|–)\s*/g;

  function cleanTextNode(node) {
    const parent = node.parentElement;
    const value = node.nodeValue;

    if (!parent || excludedTags.has(parent.tagName) || !value) return;
    if (!value.includes('--') && !value.includes('—') && !value.includes('–')) return;

    node.nodeValue = value.replace(dashCharacters, ' - ');
  }

  function cleanVisibleCopy(root) {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      cleanTextNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE || excludedTags.has(root.tagName)) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();

    while (node) {
      cleanTextNode(node);
      node = walker.nextNode();
    }
  }

  function startCopyCleanup() {
    cleanVisibleCopy(document.body);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(cleanVisibleCopy);
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCopyCleanup, { once: true });
  } else {
    startCopyCleanup();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = true;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mila-email-popup-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var dialog = root.querySelector('dialog'), form = root.querySelector('form');
    if (!dialog || !form || typeof dialog.showModal !== 'function') return;
    var state = root.querySelector('[data-form-state]').dataset.formState;
    var seenKey = 'mila_email_popup_seen', subscribedKey = 'mila_email_popup_subscribed';
    var oldShownKey = 'mila_email_popup_session_shown', oldDismissKey = 'mila_email_popup_dismissed_until';
    var pendingKey = 'mila_email_popup_pending';
    var preview = new URLSearchParams(window.location.search).get('mila_popup_preview') === '1' || !!(window.Shopify && window.Shopify.designMode);
    var timer, lastFocused, hasOpened = false, started = Date.now();
    function read(storage, key) { try { return window[storage].getItem(key); } catch (e) { return null; } }
    function write(storage, key, value) { try { window[storage].setItem(key, value); return window[storage].getItem(key) === value; } catch (e) { return false; } }
    function remove(storage, key) { try { window[storage].removeItem(key); } catch (e) {} }
    function cookieSeen() { try { return document.cookie.split(';').some(function (part) { return part.trim() === seenKey + '=1'; }); } catch (e) { return false; } }
    function remember() {
      var saved = write('localStorage', seenKey, '1');
      try { document.cookie = seenKey + '=1; Max-Age=34560000; Path=/; SameSite=Lax' + (window.location.protocol === 'https:' ? '; Secure' : ''); } catch (e) {}
      return saved || cookieSeen();
    }
    function seen() { return read('localStorage', seenKey) === '1' || cookieSeen(); }
    function stopTriggers() { window.clearTimeout(timer); window.removeEventListener('scroll', onScroll); }
    function eligible() { return !hasOpened && root.dataset.customerKnown !== 'true' && root.dataset.subscribed !== 'true' && read('localStorage', subscribedKey) !== '1' && !seen(); }
    function open(force) {
      if ((!force && !eligible()) || dialog.open || !root.isConnected) return;
      if (!preview && !force && !remember()) { stopTriggers(); return; }
      hasOpened = true;
      lastFocused = document.activeElement;
      dialog.showModal();
      document.body.classList.add('mila-signup-is-open');
      root.querySelector('[data-popup-close]').focus({preventScroll:true});
      stopTriggers();
    }
    function close() { if (!preview) remember(); dialog.close(); }
    function onScroll() {
      var distance = document.documentElement.scrollHeight - window.innerHeight;
      if (Date.now() - started >= 10000 && distance > 0 && window.scrollY / distance * 100 >= Number(root.dataset.scroll || 50)) open(false);
    }
    root.querySelectorAll('[data-popup-close]').forEach(function (button) { button.addEventListener('click', close); });
    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var items = Array.from(dialog.querySelectorAll('button:not([disabled]), input:not([disabled]):not([type="hidden"]), a[href]')).filter(function (item) { return item.getClientRects().length > 0; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
    dialog.addEventListener('click', function (event) {
      var bounds = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) close();
    });
    dialog.addEventListener('close', function () { document.body.classList.remove('mila-signup-is-open'); if (lastFocused && lastFocused.isConnected) lastFocused.focus({preventScroll:true}); });
    form.addEventListener('submit', function () { write('sessionStorage', pendingKey, form.id); });
    var isOurResponse = read('sessionStorage', pendingKey) === form.id || window.location.hash === '#' + form.id;
    if (state === 'success' && isOurResponse) { if (!preview) { remember(); write('localStorage', subscribedKey, '1'); } remove('sessionStorage', pendingKey); open(true); return; }
    if (state === 'error' && isOurResponse) { remove('sessionStorage', pendingKey); open(true); return; }
    if (preview) { open(true); return; }
    if (read('sessionStorage', oldShownKey) === '1' || Number(read('localStorage', oldDismissKey) || 0) > 0 || read('localStorage', subscribedKey) === '1') remember();
    if (!eligible() || state === 'success') return;
    timer = window.setTimeout(function () { open(false); }, Number(root.dataset.delay || 30) * 1000);
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('storage', function (event) { if (event.key === seenKey && event.newValue === '1') stopTriggers(); });
    document.addEventListener('shopify:section:unload', function (event) { if (event.target.contains(root)) { stopTriggers(); if (dialog.open) dialog.close(); } });
  }
  document.querySelectorAll('[data-mila-signup]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-mila-signup]').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mila-email-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var dialog = root.querySelector('dialog');
    if (!dialog || !dialog.showModal) return;
    var form = root.querySelector('form');
    var state = root.querySelector('[data-form-state]').dataset.formState;
    var dismissKey = 'mila_email_popup_dismissed_until';
    var subscribedKey = 'mila_email_popup_subscribed';
    var shownKey = 'mila_email_popup_session_shown';
    var pendingKey = 'mila_email_popup_pending';
    var preview = new URLSearchParams(window.location.search).get('mila_popup_preview') === '1' || (window.Shopify && window.Shopify.designMode);
    var lastFocused, timer, hasOpened = false, started = Date.now();
    function read(storage, key) { try { return window[storage].getItem(key); } catch (e) { return null; } }
    function write(storage, key, value) { try { window[storage].setItem(key, value); } catch (e) {} }
    function remove(storage, key) { try { window[storage].removeItem(key); } catch (e) {} }
    function stopTriggers() { window.clearTimeout(timer); window.removeEventListener('scroll', onScroll); }
    function eligible() {
      return !hasOpened && root.dataset.subscribed !== 'true' && read('localStorage', subscribedKey) !== '1' && read('sessionStorage', shownKey) !== '1' && Number(read('localStorage', dismissKey) || 0) < Date.now();
    }
    function open(force) {
      if (!force && !eligible()) return;
      if (dialog.open || !root.isConnected) return;
      hasOpened = true;
      lastFocused = document.activeElement;
      dialog.showModal();
      document.body.classList.add('mila-signup-is-open');
      root.querySelector('[data-popup-close]').focus({preventScroll:true});
      if (!preview) write('sessionStorage', shownKey, '1');
      stopTriggers();
    }
    function close() {
      if (!preview) write('localStorage', dismissKey, String(Date.now() + Number(root.dataset.dismissDays || 14) * 86400000));
      dialog.close();
    }
    function onScroll() {
      var distance = document.documentElement.scrollHeight - window.innerHeight;
      if (Date.now() - started >= 8000 && distance > 0 && window.scrollY / distance * 100 >= Number(root.dataset.scroll || 40)) open(false);
    }
    root.querySelectorAll('[data-popup-close]').forEach(function (button) { button.addEventListener('click', close); });
    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var items = Array.from(dialog.querySelectorAll('button:not([disabled]), input:not([disabled]):not([type="hidden"]), a[href]')).filter(function (item) { return item.getClientRects().length > 0; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
    dialog.addEventListener('click', function (event) {
      var bounds = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) close();
    });
    dialog.addEventListener('close', function () {
      document.body.classList.remove('mila-signup-is-open');
      if (lastFocused && lastFocused.isConnected) lastFocused.focus({preventScroll:true});
    });
    form.addEventListener('submit', function () { write('sessionStorage', pendingKey, form.id); });
    var isOurResponse = read('sessionStorage', pendingKey) === form.id || window.location.hash === '#' + form.id;
    if (state === 'success' && isOurResponse) {
      write('localStorage', subscribedKey, '1'); remove('sessionStorage', pendingKey); open(true); return;
    }
    if (state === 'error' && isOurResponse) { remove('sessionStorage', pendingKey); open(true); return; }
    if (preview) { open(true); return; }
    if (!eligible() || state === 'success') return;
    timer = window.setTimeout(function () { open(false); }, Number(root.dataset.delay || 30) * 1000);
    window.addEventListener('scroll', onScroll, {passive:true});
    document.addEventListener('shopify:section:unload', function (event) { if (event.target.contains(root)) { stopTriggers(); if (dialog.open) dialog.close(); } });
  }
  document.querySelectorAll('[data-mila-signup]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-mila-signup]').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["siren-header"]) return;
  try {
    
document.addEventListener('click',function(event){const skip=event.target.closest('.skip-link[href="#content"]');if(!skip)return;const content=document.getElementById('content');if(!content)return;event.preventDefault();content.focus()},{capture:true});
document.addEventListener('keydown',function(event){if(event.key!=='Escape')return;document.querySelectorAll('.siren-header details[open]').forEach(function(menu){menu.open=false;menu.querySelector('summary').focus()})});
document.addEventListener('click',function(event){document.querySelectorAll('.siren-header details[open]').forEach(function(menu){if(!menu.contains(event.target))menu.open=false})});

if (!customElements.get('siren-announcements')) {
  customElements.define('siren-announcements', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.siren-announcement__slide'));
      if (this.slides.length < 2) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.index = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.hovered = false;
      this.toggle = this.querySelector('[data-toggle]');
      this.querySelectorAll('button').forEach(button => { button.hidden = false; });
      this.querySelector('[data-previous]').addEventListener('click', () => this.manual(-1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.manual(1), options);
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); } }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
      this.addEventListener('focusin', () => this.sync(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => { if (this.isConnected) this.sync(); }), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.reduced.addEventListener('change', () => { this.paused = this.reduced.matches; this.sync(); }, options);
      this.sync();
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.abort?.abort();
    }
    show(step) {
      this.index = (this.index + step + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.tabIndex = active ? 0 : -1;
      });
    }
    manual(step) {
      this.paused = true;
      this.show(step);
      this.sync();
    }
    sync() {
      clearInterval(this.timer);
      this.toggle.toggleAttribute('data-paused', this.paused);
      this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
      if (!this.paused && !this.hovered && !document.hidden && !this.contains(document.activeElement)) {
        this.timer = setInterval(() => this.show(1), 6000);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["siren-matching-piece"]) return;
  try {
    
if (!customElements.get('siren-set-buy')) {
  customElements.define('siren-set-buy', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.selects = Array.from(this.querySelectorAll('[data-set-variant]'));
      this.button = this.querySelector('[type="submit"]');
      this.error = this.querySelector('.siren-set__error');
      this.busy = false;
      this.failed = false;
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', (event) => this.add(event));
      this.update();
    }
    selection() {
      return this.selects.map((select) => select.selectedOptions[0]);
    }
    ready() {
      return this.selects.length === 2 && this.selection().every((option) =>
        option && option.value && !option.disabled
      );
    }
    update() {
      if (this.busy || this.failed) return;
      const ready = this.ready();
      this.button.disabled = !ready;
      const available = this.selects.every((select) =>
        Array.from(select.options).some((option) => option.value && !option.disabled)
      );
      if (available) this.button.textContent = ready ? this.dataset.add : this.dataset.choose;
      if (ready) {
        const total = this.selection().reduce((sum, option) => sum + Number(option.dataset.price), 0);
        const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency', currency: 'USD', currencyDisplay: 'code'
        }).format(cents / 100);
        this.querySelector('[data-set-regular]').textContent = money(total);
        this.querySelector('[data-set-total]').textContent = money(total - 1000);
      }
    }
    async add(event) {
      event.preventDefault();
      if (this.busy || this.failed || !this.ready()) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.adding;
      this.form.setAttribute('aria-busy', 'true');
      this.selects.forEach((select) => { select.disabled = true; });
      const items = this.selection().map((option) => ({ id: Number(option.value), quantity: 1 }));
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('cart_add_failed');
        const result = await response.json();
        if (!Array.isArray(result.items) || !items.every((item) =>
          result.items.some((added) => Number(added.variant_id || added.id) === item.id)
        )) throw new Error('cart_add_unconfirmed');
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.failed = true;
        this.button.textContent = this.dataset.add;
        this.querySelector('[data-set-error]').textContent = this.dataset.error;
        this.error.hidden = false;
        this.form.removeAttribute('aria-busy');
      } finally {
        this.busy = false;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-chart"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mila-size-chart')) {
  customElements.define('mila-size-chart', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-unit]');
        if (!button || !this.contains(button)) return;
        this.querySelectorAll('button[data-unit]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelectorAll('[data-measurement]').forEach((item) => { item.hidden = item.dataset.measurement !== button.dataset.unit; });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
